/**
 * Checks whether a document exposes the imperative WebMCP API.
 * @param document - Document hosting the editor.
 * @returns True when the document can register WebMCP tools.
 */
export function IsWebMcpSupported(document) {
    return typeof document.modelContext?.registerTool === "function";
}
/**
 * Registers a set of WebMCP tools against a document.
 * @param document - Document hosting the editor.
 * @param tools - Tools to register.
 * @param signal - Signal controlling the lifetime of every registration.
 * @returns False when WebMCP is unsupported, otherwise true after all tools register.
 */
export async function RegisterWebMcpToolsAsync(document, tools, signal) {
    const modelContext = document.modelContext;
    if (!modelContext || typeof modelContext.registerTool !== "function") {
        return false;
    }
    await Promise.all(tools.map(async (tool) => {
        await modelContext.registerTool(tool, { signal });
    }));
    return true;
}
/**
 * Rejects a WebMCP mutation while a legacy editor session owns MCP writes.
 * @param legacySessionConnected - Whether the editor is connected to a legacy MCP session.
 */
export function AssertWebMcpMutationAllowed(legacySessionConnected) {
    if (legacySessionConnected) {
        throw new Error("This editor is connected to a legacy MCP session. Disconnect that session or perform the mutation through the connected MCP server.");
    }
}
//# sourceMappingURL=webMcp.js.map